export enum ReportHistoricalStatisticsType {
  LAST_RUN = 'LAST_RUN',
  CUMULATIVE = 'CUMULATIVE'
}
